import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateSetting, Setting, SettingListResponse, SettingQueryParams, UpdateSetting } from '@frontend/setting/types';

export class SettingClient extends APIClient {
    public static readonly endpoint = '/setting-api/v1';

    public static async fetchDomainSettings(domain: string, queryParams?: ApiQueryParams<SettingQueryParams>): Promise<SettingListResponse> {
        return await this.apiPaginated<SettingListResponse, SettingQueryParams>(`${this.endpoint}/domains/${domain}/settings`, queryParams, undefined, false);
    }

    public static async fetchSettings(queryParams?: ApiQueryParams<SettingQueryParams>): Promise<SettingListResponse> {
        return await this.apiPaginated<SettingListResponse, SettingQueryParams>(`${this.endpoint}/settings`, queryParams);
    }

    public static async postSetting(accountId: string, body: CreateSetting): Promise<Setting> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/settings`, body);
        return await this.handleResponse<Setting>(response);
    }

    public static async resolveSettings(ids: string[]): Promise<SettingListResponse> {
        const response = await this.post(`${this.endpoint}/settings-resolve`, { ids: ids });
        return await this.handleResponse<SettingListResponse>(response);
    }

    public static async deleteSettings(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/settings-delete`, { ids: ids });
        await this.handleVoidResponse(response);
    }

    public static async fetchSetting(accountId: string, settingId: string): Promise<Setting> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/settings/${settingId}`);
        return await this.handleResponse<Setting>(response);
    }

    public static async patchSetting(accountId: string, settingId: string, body: UpdateSetting): Promise<Setting> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/settings/${settingId}`, body);
        return await this.handleResponse<Setting>(response);
    }

    public static async deleteSetting(accountId: string, settingId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/settings/${settingId}`);
        await this.handleVoidResponse(response);
    }
}
